import { getEventPropsBuilder, toSnakeCase } from '../../utils';
import type { AmplitudeEventKeys } from '../../amplitude-properties.types';

/**
 * User taps a collection tile on the home lobby (part of epic hub).
 */
export const getGameCollectionSelectedProps = getEventPropsBuilder(
    (gameCollectionUid: string, zoneTitle: string): Partial<AmplitudeEventKeys> => ({
        event: 'Game Collection Selected',
        'Page Name': 'home',
        Module: toSnakeCase(zoneTitle),
        'Game Collection Name': toSnakeCase(gameCollectionUid)
    })
);
